import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from '../';
import LiveCam from '../../containers/LiveCam';
import ServerError from './ServerError';

const defaultProps = {
  debug: false,
  initialDataLoaded: false,
  userId: null,
};

const propTypes = {
  debug: PropTypes.bool,
  initialDataLoaded: PropTypes.bool,
  userId: PropTypes.string,
};

class InitialLoad extends React.Component {
  componentWillMount() {
    $('body').addClass('main-grey-bkg');
  }

  render() {
    const { initialDataLoaded, error, ...rest } = this.props;

    if (error) {
      return (<ServerError error={error} />);
    }

    if (initialDataLoaded) {
      return (
        <LiveCam {...rest} />
      );
    }
    return (
      <div><Loader dark fill /></div>
    );
  }
}

InitialLoad.defaultProps = defaultProps;
InitialLoad.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    initialDataLoaded: state.globalConfig.initialDataLoaded,
    error: state.globalConfig.initialLoadError,
    userId: state.auth.userId,
  };
};

export default connect(mapStateToProps)(InitialLoad);
